import { render, staticRenderFns } from "./CrearMovimiento.vue?vue&type=template&id=b4c48116&scoped=true"
import script from "./CrearMovimiento.vue?vue&type=script&lang=js"
export * from "./CrearMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c48116",
  null
  
)

export default component.exports